import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NangLuc from "../pages/nang-luc/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nang-luc",
    element: <NangLuc />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
